import React from 'react'
import { XYChart, AnimatedAxis, AnimatedAreaSeries, DataProvider, Tooltip } from '@visx/xychart'
import { LinearGradient } from '@visx/gradient'
import { ParentSize } from '@visx/responsive'
import { Pane, Text } from '@leverege/ui-elements'

import { chartTheme } from '../../../../util/Theme'
import useTrafficAreaChart from '../hooks/useTrafficAreaChart'
import ChartLegend from './ChartLegend'
import ChartTypeSelector from '../../aisleHeatmapping/ChartTypeSelector'
import GenericTooltip from '../../views/GenericTooltip'

export default function TrafficAreaGraph( props ) {
  const { data, config, type, onSetType } = useTrafficAreaChart( props )

  return (
    <Pane variant="cardNoPad" layout="flex:col">
      <div style={{
        height : '60px',
        padding : 'var(--size-padLarge)',
        borderBottom : '1px solid var(--color-base100)'
      }}>
        <Text variant="subtitle">Traffic By Time of Day</Text>
      </div>
      <div style={{
        height : 'calc(100% - 60px)',
        padding : '0 var(--size-padLarge) var(--size-padLarge) var(--size-padLarge)'
      }}>
        <ParentSize
          parentSizeStyles={{
            overflow : 'hidden',
            width : '100%',
            height : '100%',
            position : 'relative'
          }}>
          {( { width, height } ) => ( 
            <DataProvider
              theme={chartTheme}
              xScale={config.scale.x}
              yScale={config.scale.y}>
              <XYChart
                width={width}
                height={height - 20}>
                <LinearGradient
                  id="personGradient"
                  from={chartTheme.colors[0]}
                  fromOpacity={0.5}
                  toOpacity={0}
                  to={chartTheme.colors[0]} />
                <LinearGradient
                  id="dogGradient"
                  from={chartTheme.colors[1]}
                  fromOpacity={0.5}
                  toOpacity={0}
                  to={chartTheme.colors[1]} />
                <AnimatedAxis
                  orientation="left"
                  numTicks={10}
                  label="Traffic" />
                <AnimatedAxis
                  tickFormat={config.tickFormat.x}
                  orientation="bottom"
                  numTicks={data.length} />
                <AnimatedAreaSeries
                  fillOpacity={0.5}
                  fill="url(#personGradient)"
                  renderLine
                  dataKey="person"
                  data={data}
                  {...config.accessors.person} />
                <AnimatedAreaSeries
                  fillOpacity={0.5}
                  fill="url(#dogGradient)"
                  renderLine
                  dataKey="dog"
                  data={data}
                  {...config.accessors.dog} />
                <Tooltip
                  scroll
                  detectBounds
                  showSeriesGlyphs
                  showVerticalCrosshair
                  showDatumGlyph={false}
                  snapTooltipToDatumX={false}
                  snapTooltipToDatumY={false}
                  renderTooltip={props => (
                    <GenericTooltip {...props} config={config} />
                  )} />
              </XYChart>
              <ChartLegend />
              <ChartTypeSelector small value={type} onChange={onSetType} />
            </DataProvider>
          )}
        </ParentSize>
      </div>
    </Pane>
  )
}
